import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for C505 (銷貨退回單核准)
// ============================================================

export interface PendingItem {
  fc130_01: string;        // 退回單號
  fc130_10: string;        // 出貨單號
  fc130_11: string | null; // 退回日期 (ISO string)
  fc130_12: string;        // 客戶代號
  fc130_13: number;        // 總退回數量
  fc130_91: string;        // 建單員工代號
  customer_name: string;   // 客戶名稱 (F105_11 lookup)
  can_approve: boolean;    // 此用戶是否可核准
}

export interface QueryResponse {
  items: PendingItem[];
  total: number;
}

export interface ApproveResultItem {
  return_no: string;
  success: boolean;
  message: string;
}

export interface ExecuteResponse {
  results: ApproveResultItem[];
  success: number;
  failed: number;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const c505Api = {
  /** Query pending sales return orders within a range */
  async query(startNo: string, endNo: string): Promise<QueryResponse> {
    const res = await apiClient.post<QueryResponse>('/api/c505/query', {
      start_no: startNo,
      end_no: endNo,
    });
    return res.data;
  },

  /** Execute batch approval for selected sales return orders */
  async execute(returnNos: string[]): Promise<ExecuteResponse> {
    const res = await apiClient.post<ExecuteResponse>('/api/c505/execute', {
      return_nos: returnNos,
    });
    return res.data;
  },
};
